import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { PdvActions } from '../actions';
import { PdvService } from 'src/app/services/pdv.service';

@Injectable()
export class PdvEffects {
  loadPdv$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PdvActions.loadPdv),
      mergeMap(() => {
        return this.pdvService.load().pipe(
          map((pdv) => {
            return PdvActions.loadPdvSuccess(pdv);
          })
        )
      })
    )
  );

  constructor(
    private actions$: Actions,
    private pdvService: PdvService,
  ) {}
}
